'use strict';

var cov_15uhxa2w92 = function () {
  var path = 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\header.js',
      hash = 'd70ff3892c547f69c19bff102fc62818a25ce2ff',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\giutien-viettel\\client-giutien\\src\\app\\header.js',
    statementMap: {
      '0': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 30
        }
      },
      '1': {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 28
        }
      },
      '2': {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 43
        }
      },
      '3': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 30
        }
      },
      '4': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 47
        }
      },
      '5': {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 13,
          column: 41
        }
      },
      '6': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 36,
          column: 6
        }
      },
      '7': {
        start: {
          line: 17,
          column: 26
        },
        end: {
          line: 17,
          column: 87
        }
      },
      '8': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 30,
          column: 11
        }
      },
      '9': {
        start: {
          line: 27,
          column: 10
        },
        end: {
          line: 27,
          column: 75
        }
      },
      '10': {
        start: {
          line: 29,
          column: 10
        },
        end: {
          line: 29,
          column: 54
        }
      },
      '11': {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 35,
          column: 9
        }
      },
      '12': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 32,
          column: 48
        }
      },
      '13': {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 34,
          column: 61
        }
      },
      '14': {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 39,
          column: 32
        }
      },
      '15': {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 40,
          column: 36
        }
      },
      '16': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 43,
          column: 8
        }
      },
      '17': {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 25
        }
      },
      '18': {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 46,
          column: 8
        }
      },
      '19': {
        start: {
          line: 45,
          column: 8
        },
        end: {
          line: 45,
          column: 27
        }
      },
      '20': {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 88,
          column: 8
        }
      },
      '21': {
        start: {
          line: 48,
          column: 20
        },
        end: {
          line: 48,
          column: 53
        }
      },
      '22': {
        start: {
          line: 49,
          column: 19
        },
        end: {
          line: 49,
          column: 52
        }
      },
      '23': {
        start: {
          line: 50,
          column: 23
        },
        end: {
          line: 53,
          column: 9
        }
      },
      '24': {
        start: {
          line: 54,
          column: 23
        },
        end: {
          line: 57,
          column: 9
        }
      },
      '25': {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 87,
          column: 11
        }
      },
      '26': {
        start: {
          line: 59,
          column: 10
        },
        end: {
          line: 86,
          column: 11
        }
      },
      '27': {
        start: {
          line: 60,
          column: 12
        },
        end: {
          line: 60,
          column: 47
        }
      },
      '28': {
        start: {
          line: 61,
          column: 12
        },
        end: {
          line: 61,
          column: 29
        }
      },
      '29': {
        start: {
          line: 62,
          column: 12
        },
        end: {
          line: 62,
          column: 37
        }
      },
      '30': {
        start: {
          line: 63,
          column: 12
        },
        end: {
          line: 67,
          column: 15
        }
      },
      '31': {
        start: {
          line: 68,
          column: 12
        },
        end: {
          line: 68,
          column: 29
        }
      },
      '32': {
        start: {
          line: 69,
          column: 12
        },
        end: {
          line: 73,
          column: 13
        }
      },
      '33': {
        start: {
          line: 70,
          column: 14
        },
        end: {
          line: 70,
          column: 68
        }
      },
      '34': {
        start: {
          line: 71,
          column: 14
        },
        end: {
          line: 71,
          column: 55
        }
      },
      '35': {
        start: {
          line: 72,
          column: 14
        },
        end: {
          line: 72,
          column: 34
        }
      },
      '36': {
        start: {
          line: 75,
          column: 12
        },
        end: {
          line: 79,
          column: 15
        }
      },
      '37': {
        start: {
          line: 80,
          column: 12
        },
        end: {
          line: 85,
          column: 13
        }
      },
      '38': {
        start: {
          line: 81,
          column: 14
        },
        end: {
          line: 81,
          column: 31
        }
      },
      '39': {
        start: {
          line: 83,
          column: 14
        },
        end: {
          line: 83,
          column: 51
        }
      },
      '40': {
        start: {
          line: 84,
          column: 14
        },
        end: {
          line: 84,
          column: 31
        }
      },
      '41': {
        start: {
          line: 93,
          column: 0
        },
        end: {
          line: 113,
          column: 5
        }
      },
      '42': {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 108,
          column: 3
        }
      },
      '43': {
        start: {
          line: 98,
          column: 21
        },
        end: {
          line: 98,
          column: 31
        }
      },
      '44': {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 105,
          column: 11
        }
      },
      '45': {
        start: {
          line: 101,
          column: 10
        },
        end: {
          line: 101,
          column: 42
        }
      },
      '46': {
        start: {
          line: 104,
          column: 10
        },
        end: {
          line: 104,
          column: 36
        }
      },
      '47': {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 106,
          column: 30
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 4,
            column: 3
          }
        },
        loc: {
          start: {
            line: 4,
            column: 109
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 4
      },
      '1': {
        name: 'toggleCollapse',
        decl: {
          start: {
            line: 11,
            column: 13
          },
          end: {
            line: 11,
            column: 27
          }
        },
        loc: {
          start: {
            line: 11,
            column: 30
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 11
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 16,
            column: 26
          },
          end: {
            line: 16,
            column: 27
          }
        },
        loc: {
          start: {
            line: 16,
            column: 40
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 16
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 26,
            column: 14
          },
          end: {
            line: 26,
            column: 15
          }
        },
        loc: {
          start: {
            line: 26,
            column: 32
          },
          end: {
            line: 28,
            column: 9
          }
        },
        line: 26
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 28,
            column: 11
          },
          end: {
            line: 28,
            column: 12
          }
        },
        loc: {
          start: {
            line: 28,
            column: 23
          },
          end: {
            line: 30,
            column: 9
          }
        },
        line: 28
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 31,
            column: 20
          },
          end: {
            line: 31,
            column: 21
          }
        },
        loc: {
          start: {
            line: 31,
            column: 32
          },
          end: {
            line: 33,
            column: 7
          }
        },
        line: 31
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 10
          }
        },
        loc: {
          start: {
            line: 33,
            column: 36
          },
          end: {
            line: 35,
            column: 7
          }
        },
        line: 33
      },
      '7': {
        name: 'DialogController',
        decl: {
          start: {
            line: 38,
            column: 13
          },
          end: {
            line: 38,
            column: 29
          }
        },
        loc: {
          start: {
            line: 38,
            column: 64
          },
          end: {
            line: 89,
            column: 5
          }
        },
        line: 38
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 41,
            column: 20
          },
          end: {
            line: 41,
            column: 21
          }
        },
        loc: {
          start: {
            line: 41,
            column: 32
          },
          end: {
            line: 43,
            column: 7
          }
        },
        line: 41
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 44,
            column: 22
          },
          end: {
            line: 44,
            column: 23
          }
        },
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 46,
            column: 7
          }
        },
        line: 44
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 47,
            column: 21
          },
          end: {
            line: 47,
            column: 22
          }
        },
        loc: {
          start: {
            line: 47,
            column: 33
          },
          end: {
            line: 88,
            column: 7
          }
        },
        line: 47
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 58,
            column: 61
          },
          end: {
            line: 58,
            column: 62
          }
        },
        loc: {
          start: {
            line: 58,
            column: 71
          },
          end: {
            line: 87,
            column: 9
          }
        },
        line: 58
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 21
          }
        },
        loc: {
          start: {
            line: 95,
            column: 51
          },
          end: {
            line: 109,
            column: 1
          }
        },
        line: 95
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 97,
            column: 9
          },
          end: {
            line: 97,
            column: 10
          }
        },
        loc: {
          start: {
            line: 97,
            column: 20
          },
          end: {
            line: 107,
            column: 5
          }
        },
        line: 97
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 100,
            column: 14
          },
          end: {
            line: 100,
            column: 15
          }
        },
        loc: {
          start: {
            line: 100,
            column: 32
          },
          end: {
            line: 102,
            column: 9
          }
        },
        line: 100
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 103,
            column: 15
          },
          end: {
            line: 103,
            column: 16
          }
        },
        loc: {
          start: {
            line: 103,
            column: 33
          },
          end: {
            line: 105,
            column: 9
          }
        },
        line: 103
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 17,
            column: 26
          },
          end: {
            line: 17,
            column: 87
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 17,
            column: 27
          },
          end: {
            line: 17,
            column: 41
          }
        }, {
          start: {
            line: 17,
            column: 45
          },
          end: {
            line: 17,
            column: 59
          }
        }, {
          start: {
            line: 17,
            column: 64
          },
          end: {
            line: 17,
            column: 87
          }
        }],
        line: 17
      },
      '1': {
        loc: {
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 32,
            column: 15
          },
          end: {
            line: 32,
            column: 29
          }
        }, {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 32,
            column: 47
          }
        }],
        line: 32
      },
      '2': {
        loc: {
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 86,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 86,
            column: 11
          }
        }, {
          start: {
            line: 59,
            column: 10
          },
          end: {
            line: 86,
            column: 11
          }
        }],
        line: 59
      },
      '3': {
        loc: {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        }, {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 73,
            column: 13
          }
        }],
        line: 69
      },
      '4': {
        loc: {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 85,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 85,
            column: 13
          }
        }, {
          start: {
            line: 80,
            column: 12
          },
          end: {
            line: 85,
            column: 13
          }
        }],
        line: 80
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    b: {
      '0': [0, 0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderController =
/** @ngInject */
function HeaderController($scope, $http, $mdMedia, $mdDialog, $state, $rootScope, ngNotify, myVars, localStorageService) {
  _classCallCheck(this, HeaderController);

  ++cov_15uhxa2w92.f[0];
  ++cov_15uhxa2w92.s[0];

  $scope.isCollapsed = true;
  ++cov_15uhxa2w92.s[1];
  $scope.showmenu = false;
  ++cov_15uhxa2w92.s[2];
  $scope.toggleCollapse = toggleCollapse;
  ++cov_15uhxa2w92.s[3];
  $scope.checkinfo = myVars;
  // noinspection JSAnnotator

  function toggleCollapse() {
    ++cov_15uhxa2w92.f[1];
    ++cov_15uhxa2w92.s[4];

    $scope.isCollapsed = !$scope.isCollapsed;
    ++cov_15uhxa2w92.s[5];
    $scope.showmenu = !$scope.showmenu;
  }

  ++cov_15uhxa2w92.s[6];
  $scope.showAdvanced = function (ev) {
    ++cov_15uhxa2w92.f[2];

    var useFullScreen = (++cov_15uhxa2w92.s[7], ((++cov_15uhxa2w92.b[0][0], $mdMedia('sm')) || (++cov_15uhxa2w92.b[0][1], $mdMedia('xs'))) && (++cov_15uhxa2w92.b[0][2], $scope.customFullscreen));
    ++cov_15uhxa2w92.s[8];
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'app/dialog.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      escapeToClose: false
    }).then(function (answer) {
      ++cov_15uhxa2w92.f[3];
      ++cov_15uhxa2w92.s[9];

      $scope.status = 'You said the information was "' + answer + '".';
    }, function () {
      ++cov_15uhxa2w92.f[4];
      ++cov_15uhxa2w92.s[10];

      $scope.status = 'You cancelled the dialog.';
    });
    ++cov_15uhxa2w92.s[11];
    $scope.$watch(function () {
      ++cov_15uhxa2w92.f[5];
      ++cov_15uhxa2w92.s[12];

      return (++cov_15uhxa2w92.b[1][0], $mdMedia('xs')) || (++cov_15uhxa2w92.b[1][1], $mdMedia('sm'));
    }, function (wantsFullScreen) {
      ++cov_15uhxa2w92.f[6];
      ++cov_15uhxa2w92.s[13];

      $scope.customFullscreen = wantsFullScreen === true;
    });
  };

  function DialogController($scope, $mdDialog, types, $state) {
    ++cov_15uhxa2w92.f[7];
    ++cov_15uhxa2w92.s[14];

    $scope.checkinfo = myVars;
    ++cov_15uhxa2w92.s[15];
    $scope.showClose = types.data;
    ++cov_15uhxa2w92.s[16];
    $scope.hide = function () {
      ++cov_15uhxa2w92.f[8];
      ++cov_15uhxa2w92.s[17];

      $mdDialog.hide();
    };
    ++cov_15uhxa2w92.s[18];
    $scope.cancel = function () {
      ++cov_15uhxa2w92.f[9];
      ++cov_15uhxa2w92.s[19];

      $mdDialog.cancel();
    };
    ++cov_15uhxa2w92.s[20];
    $scope.login = function () {
      ++cov_15uhxa2w92.f[10];

      var key = (++cov_15uhxa2w92.s[21], CryptoJS.lib.WordArray.random(16));
      var iv = (++cov_15uhxa2w92.s[22], CryptoJS.lib.WordArray.random(16));
      var member = (++cov_15uhxa2w92.s[23], {
        username: CryptoJS.AES.encrypt($scope.username, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString(),
        password: CryptoJS.AES.encrypt($scope.password, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString()
      });
      var config = (++cov_15uhxa2w92.s[24], {
        params: member,
        headers: { Accept: 'application/json' }
      });
      ++cov_15uhxa2w92.s[25];
      $http.get($rootScope.apiOpen + 'login', config).then(function (result) {
        ++cov_15uhxa2w92.f[11];
        ++cov_15uhxa2w92.s[26];

        if (result.data.status === '0') {
          ++cov_15uhxa2w92.b[2][0];
          ++cov_15uhxa2w92.s[27];

          myVars.msisdn = result.data.msisdn;
          ++cov_15uhxa2w92.s[28];
          myVars.login = 1;
          ++cov_15uhxa2w92.s[29];
          myVars.checkMember = '0';
          ++cov_15uhxa2w92.s[30];
          ngNotify.set('Chào mừng 0' + result.data.msisdn, {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          ++cov_15uhxa2w92.s[31];
          $mdDialog.hide();
          ++cov_15uhxa2w92.s[32];
          if (localStorageService.isSupported) {
            ++cov_15uhxa2w92.b[3][0];
            ++cov_15uhxa2w92.s[33];

            localStorageService.set('msisdn', result.data.msisdn);
            ++cov_15uhxa2w92.s[34];
            localStorageService.set('islogin', true);
            ++cov_15uhxa2w92.s[35];
            myVars.login = true;
          } else {
            ++cov_15uhxa2w92.b[3][1];
          }
        } else {
          ++cov_15uhxa2w92.b[2][1];
          ++cov_15uhxa2w92.s[36];

          ngNotify.set('Bạn chưa đăng ký dịch vụ hoặc mật khẩu không chính xác !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
          ++cov_15uhxa2w92.s[37];
          if (types === true) {
            ++cov_15uhxa2w92.b[4][0];
            ++cov_15uhxa2w92.s[38];

            $mdDialog.hide();
          } else {
            ++cov_15uhxa2w92.b[4][1];
            ++cov_15uhxa2w92.s[39];

            $state.go('app', {}, { reload: true });
            ++cov_15uhxa2w92.s[40];
            $mdDialog.hide();
          }
        }
      });
    };
  }
};

++cov_15uhxa2w92.s[41];

angular.module('app').factory("Slide", function ($http, $q, $rootScope) {
  ++cov_15uhxa2w92.f[12];
  ++cov_15uhxa2w92.s[42];

  return {
    get: function get() {
      ++cov_15uhxa2w92.f[13];

      var deferred = (++cov_15uhxa2w92.s[43], $q.defer());
      ++cov_15uhxa2w92.s[44];
      $http.get($rootScope.apiOpen + 'slide/find').then(function (response) {
        ++cov_15uhxa2w92.f[14];
        ++cov_15uhxa2w92.s[45];

        deferred.resolve(response.data);
      }).catch(function (response) {
        ++cov_15uhxa2w92.f[15];
        ++cov_15uhxa2w92.s[46];

        deferred.reject(response);
      });
      ++cov_15uhxa2w92.s[47];
      return deferred.promise;
    }
  };
}).component('fountainHeader', {
  templateUrl: 'app/header.html',
  controller: HeaderController
});